// When an auth link is invalid, Supabase redirects to its configured URL with
// an error appended instead of a token — most often an expired or already-used
// invite/recovery/magic link:
//   #error=access_denied&error_code=otp_expired&error_description=Email+link+is+invalid+or+has+expired
// Depending on the flow the error rides in the hash fragment or the query
// string. This parses either into a structured result; each caller maps the
// code to its own user-facing copy (admin vs vendor wording differ).
export type AuthUrlError = {
  code: string | null;
  description: string | null;
};

export function parseAuthErrorFromUrl(search: string, hash: string): AuthUrlError | null {
  const fromHash = hash ? new URLSearchParams(hash.replace(/^#/, '')) : null;
  const fromQuery = search ? new URLSearchParams(search.replace(/^\?/, '')) : null;

  const error = fromHash?.get('error') ?? fromQuery?.get('error') ?? '';
  const code = fromHash?.get('error_code') ?? fromQuery?.get('error_code') ?? '';
  // URLSearchParams already decodes '+' to spaces for us.
  const description = fromHash?.get('error_description') ?? fromQuery?.get('error_description') ?? '';

  if (!error && !code && !description) return null;

  return { code: code || null, description: description || null };
}
